import { SgwtMiniFooter } from '@sgwt/sgwt-widgets-react';

import { getConfig } from '@/config/config.ts';

export const APP_FOOTER_ID = 'footer';

export function Footer() {
  const { environment } = getConfig().app;
  const frontVersion = getConfig().frontVersion;

  return (
    <footer id={APP_FOOTER_ID} className="bg-lvl1">
      <SgwtMiniFooter
        size="sm"
        design="light"
        mode="sg-markets"
        about={{
          label: environment !== 'production' ? `${environment.toUpperCase()} - ${frontVersion}` : frontVersion,
        }}
        cookiesConsent={environment !== 'devci'}
        contactUsByHelpCenter="sgwt-help-center"
      />
    </footer>
  );
}
